import React, { useState, useEffect } from "react";
import styles from './Footer.module.css';
import SText from "../../components/SText";
import Colors from "../../components/utils/Colors";
import { NavLink } from "react-router-dom";

const CookieFloat = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
            setIsVisible(true);
        }
    }, []);

    const agreeWithCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
        
        document.cookie = "cookie_consent=true; path=/; max-age=" + 60 * 60 * 24 * 365; // на год
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles.cookieFloat}>
            <div className={styles.cookieText}>
                Используем <a href="/company/pravila-primeneniya-rekomendatelnyh-tehnologiy" target="_blank">рекомендательные технологии</a> и собираем файлы cookie для аналитики и правильной работы сайта. Оставаясь на сайте вы <a href="/company/politika-obrabotki-cookie-faylov" target="_blank">соглашаетесь с обработков файлов cookie</a>.
            </div>
            <a className={styles.cookieAgree} onClick={agreeWithCookies}>
                Соглашаюсь
            </a>
        </div>
    );
};

export default CookieFloat;